import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { X } from 'lucide-react';

type PillInputBaseProps = {
  badges: string[];
  value: string;
  disabled: boolean;
  placeholder?: string;
  inputError: string;
  onInputChange: (value: string) => void;
  onKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onDelete: (item: string) => void;
  badgeSize?: number;
};

export function PillInputBase({
  badges,
  value,
  disabled,
  placeholder,
  inputError,
  onInputChange,
  onKeyDown,
  onBlur,
  onDelete,
  badgeSize,
}: PillInputBaseProps) {
  const badgePillSize = badgeSize ? 100 / badgeSize : 25;

  return (
    <div>
      <div
        data-pill-input-root
        className='flex rounded-md border border-input px-2 py-2 items-center flex-wrap'
      >
        <div className='w-full flex items-center flex-wrap'>
          {badges.map((badge) => (
            <Badge
              key={badge}
              className={`py-2 px-4 m-1 rounded-3xl items-center justify-center hover:bg-primary ${
                disabled
                  ? 'bg-[#878b95] hover:bg-gray-400 pointer-events-none'
                  : ''
              }`}
              style={{ flexBasis: `calc(${badgePillSize}% - 0.5rem)` }}
            >
              <div
                className={`flex items-center w-full ${
                  disabled ? 'justify-center' : 'justify-between'
                }`}
              >
                {badge}
                {!disabled && (
                  <Button
                    variant='secondary'
                    className='bg-primary hover:bg-secondary/20 cursor-pointer h-4 w-4 rounded-full p-4 text-white'
                    disabled={disabled}
                    onMouseDown={(e) => e.preventDefault()}
                    onClick={(e) => {
                      e.preventDefault();
                      onDelete(badge);
                    }}
                  >
                    <X className='h-4 w-4' />
                  </Button>
                )}
              </div>
            </Badge>
          ))}
          <Input
            disabled={disabled}
            onChange={(e) => onInputChange(e.target.value)}
            value={value}
            className={`flex-1 border-none outline-none focus:outline-0 focus-within:outline-0 focus-visible:outline-0 focus:ring-0 focus-visible:focus:ring-0 focus-visible:focus:ring-offset-0 ${
              badges.length >= 4 ? 'mt-2' : ''
            }`}
            placeholder={placeholder}
            onKeyDown={onKeyDown}
            onBlur={onBlur}
          />
        </div>
      </div>
      {inputError && <p className='text-red-500 text-sm'>{inputError}</p>}
    </div>
  );
}
